// removed by extract-text-webpack-plugin
module.exports = {"container":"dQk2o9E2ozcgnNAMTzoFw","button":"sCLUOnEzwzKqSJZGFasIM"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/confirm-checkout/error-modal/ErrorModal.css
// module id = 837
// module chunks = 0